import { IsBoolean } from 'class-validator';

export class SubmitAssessmentResult {
  @IsBoolean()
  success: boolean;
}
